import {MenuItem, Popover} from "@mui/material";
import React from "react";
import Iconify from "../iconify";

export default function ContextMenu({target, setTarget, handleEdit, handleDelete, handleComment, handleStats}) {
    return (
        <Popover
            open={Boolean(target)}
            anchorEl={target}
            onClose={() => setTarget(null)}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
                sx: {
                    p: 1,
                    width: 140,
                    '& .MuiMenuItem-root': {
                        px: 1,
                        typography: 'body2',
                        borderRadius: 0.75,
                    }
                }
            }}
        >
            {handleEdit && (
                <MenuItem
                    onClick={() => {
                        setTarget(null);
                        handleEdit();
                    }}
                >
                    <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
                    Editer
                </MenuItem>
            )}
            {handleDelete && (
                <MenuItem
                    sx={{ color: 'error.main' }}
                    onClick={() => {
                        setTarget(null);
                        handleDelete();
                    }}
                >
                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                    Supprimer
                </MenuItem>
            )}
            {handleComment && (
                <MenuItem
                    onClick={() => {
                        setTarget(null);
                        handleComment();
                    }}
                >
                    <Iconify icon={'eva:message-square-outline'} sx={{ mr: 2 }} />
                    Commenter
                </MenuItem>
            )}
            {handleStats && (
                <MenuItem
                    onClick={() => {
                        setTarget(null);
                        handleStats();
                    }}
                >
                    <Iconify icon={'eva:bar-chart-outline'} sx={{ mr: 2 }} />
                    Statistiques
                </MenuItem>
            )}
        </Popover>
    );
}